import useApi from "../useApi";
import {
  IUpdateBillingMinutesReq,
  IUpdateBillingMinutesRes,
} from "./index.type";
import toast from "react-hot-toast";

interface UseUpdateBillingMinutesProps {
  billingCycleId: string;
}

const useUpdateBillingMinutes = ({
  billingCycleId,
}: UseUpdateBillingMinutesProps) => {
  const { loading: updateBillingMinutesLoading, makeApiCall } = useApi({
    url: `/rtm/timer/minutes?billingCycleId=${billingCycleId}`,
    method: "PUT",
  });

  const updateBillingMinutesData = async (data: IUpdateBillingMinutesReq) => {
    if (!billingCycleId) return;

    const { response, error } = await makeApiCall<
      IUpdateBillingMinutesReq,
      IUpdateBillingMinutesRes
    >(data);

    if (response?.status === "success") {
      toast.success(response.meessage);
      return response;
    }
    if (response?.status === "fail") {
      toast.error(response.meessage);
      return null;
    }

    if (error) {
      toast.error(error.msg ?? error.message);
      return null;
    }
  };

  return {
    updateBillingMinutesLoading,
    updateBillingMinutesData,
  };
};

export default useUpdateBillingMinutes;
